module.exports = __webpack_public_path__ + "static/img/sfclogo.94bf2df3.png";